export enum LanguageId {
    En = 1,
    Hu = 2,
}
